module.exports = __webpack_public_path__ + "img/solution--pressure-injury-prevention.60f63e46.jpg";